"use strict";

import { newVueComponent, waitForDependencies } from "../_imports/utils/utils.common";

const componentName = "search-by-skills-light";

waitForDependencies(() => newVueComponent(componentName, () => require("./_imports/search-by-skills-light.vue").default));
